import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { RouterHistoryService } from '~/core/services/router-history/router-history.service';
import { ActivitySelectionService } from '~/organizer/activity-planning/services/activity-selection.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  constructor(
    private readonly activitySelectionService: ActivitySelectionService,
    private readonly routerHistoryService: RouterHistoryService
  ) {}

  public canActivate(): true {
    const currentUrl = this.routerHistoryService.current;
    const previousUrl = this.routerHistoryService.previous;

    if (previousUrl) {
      // /locale/module-path/... => module-path
      const currentModulePath = currentUrl.split('/')[2];

      // Is coming from an other module.
      if (!previousUrl.includes(currentModulePath)) {
        this.activitySelectionService.resetCreatedTimeslots();
        this.activitySelectionService.resetExistingTimeslots();
      }
    }

    return true;
  }
}

export const OrganizerSharedClearTimeslotGuard: CanActivateFn = (): true => {
  return inject(PermissionsService).canActivate();
};
